const config = {
    CLOUDINARY_URL: 'https://res.cloudinary.com/theloge/image/upload/',
    PARSE_URL: 'https://the-loge.com/parse',
    STAGING_PARSE_URL: 'http://104.248.138.45/parse',
    DIRECTUS_BACKEND: 'https://the-loge.com/backend/',
    // DIRECTUS_BACKEND: 'https://theloge.fuchsfabrik.solutions/backend/',
    DEV_PARSE_URL: 'https://the-loge.com/parse',
    PARSE_JSKEY: 'theloge',
    PARSE_APPID: 'TheLoge',
    CLOUDINARY_API_KEY: '176446663253312',
    CLOUDINARY_API_SECRET: 'PD0h5sq7XcrtzqgyZMkx5WfqaI8',
    CLOUDINARY_CLOUD_NAME: 'theloge',
    CLOUDINARY_UPLOAD_URL: 'https://api.cloudinary.com/v1_1/theloge/image/upload',
    CLOUDINARY_PRESET: 'y9ddr9xh'
};

export default config;


// WEBPACK FOOTER //
// /src/GlobalConfig.js